/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ResponseBase,
    ResponseBaseFromJSON,
    ResponseBaseFromJSONTyped,
    ResponseBaseToJSON,
    Standard,
    StandardFromJSON,
    StandardFromJSONTyped,
    StandardToJSON,
} from './';

/**
 * 
 * @export
 * @interface StandardsListResponse
 */
export interface StandardsListResponse {
    /**
     * Message related to response
     * @type {string}
     * @memberof StandardsListResponse
     */
    msg: string;
    /**
     * 
     * @type {Array<Standard>}
     * @memberof StandardsListResponse
     */
    entries: Array<Standard>;
}

export function StandardsListResponseFromJSON(json: any): StandardsListResponse {
    return StandardsListResponseFromJSONTyped(json, false);
}

export function StandardsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StandardsListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'msg': json['msg'],
        'entries': ((json['entries'] as Array<any>).map(StandardFromJSON)),
    };
}

export function StandardsListResponseToJSON(value?: StandardsListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'msg': value.msg,
        'entries': ((value.entries as Array<any>).map(StandardToJSON)),
    };
}


